import Icon from '@ant-design/icons'

const Knowledage = () => (
    <svg
        t='1776931191476'
        class='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='5384'
        className='icon'
    >
        <path
            d='M64 192v640c0 70.7 57.3 128 128 128V64c-70.7 0-128 57.3-128 128zM832 64v255.1L703.8 192 576 320V64H256v896h576c70.7 0 128-57.3 128-128V192c0-70.7-57.3-128-128-128z m0 640H384v-64h448v64z m0-192H384v-64h448v64z'
            fill='currentColor'
            p-id='5385'
        ></path>
    </svg>
)

export const KnowledageIcon = props => <Icon component={Knowledage} {...props} />
